var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { selectPages } from "@adm-media/adam-store-plugin";
import { Link } from "react-router-dom";
import { useNavigateWithParams } from "./useNavigateWithParams";
var usePages = function () {
    var pages = useSelector(selectPages);
    var navigate = useNavigateWithParams();
    var filter = function (value) {
        return pages === null || pages === void 0 ? void 0 : pages.filter(function (page) {
            switch (value) {
                case "takeaway":
                    return page.is_takeaway;
                case "related":
                    return page.is_related;
                case "highlighted":
                    return page.is_highlighted;
            }
        });
    };
    var getMedia = function (_a) {
        var _b;
        var item = _a.item, filter = _a.filter;
        return (_b = item.media) === null || _b === void 0 ? void 0 : _b.find(function (img) { return img.keyname === filter; });
    };
    var getMediaUrl = function (_a) {
        var _b;
        var item = _a.item, filter = _a.filter;
        return ((_b = getMedia({ item: item, filter: filter })) === null || _b === void 0 ? void 0 : _b.url) || "";
    };
    var handleLink = function (item, origin) {
        var linkUrl = null;
        var linkTarget = undefined;
        if (item.is_internal_url && item.slug) {
            linkUrl = "/pages/".concat(item.slug);
        }
        if (!item.is_internal_url && item.external_link) {
            linkUrl = item.external_link;
            linkTarget = "_blank";
        }
        var handleCardClick = linkUrl
            ? function () {
                if (item.is_internal_url)
                    navigate(linkUrl, origin ? { state: { from: origin } } : undefined);
                else
                    window.open(linkUrl, "_blank", "noopener,noreferrer");
            }
            : undefined;
        var cardTitle = linkUrl ? (item.is_internal_url ? (_jsx(Link, __assign({ to: linkUrl, onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleCardClick === null || handleCardClick === void 0 ? void 0 : handleCardClick();
            } }, { children: item.title }))) : (_jsx("a", __assign({ href: linkUrl, target: "_blank", rel: "noopener noreferrer", onClick: function (e) { return e.stopPropagation(); } }, { children: item.title })))) : (item.title);
        return { handleCardClick: handleCardClick, cardTitle: cardTitle, linkTarget: linkTarget };
    };
    return { filter: filter, getMedia: getMedia, getMediaUrl: getMediaUrl, handleLink: handleLink };
};
export default usePages;
